import { Link } from 'react-router-dom'
import { IS_COMPANY, VIEWPORT_LG } from '../../utils/constants'
import useResize from '../../hooks/useResize'
import schedule_call_banner_mobile from './icons/schedule_call_banner_mobile.svg'
import long_wait_time_banner from './icons/long_wait_time_banner.svg'
import ScheduleCallBannerSkeleton from './skeleton/ScheduleCallBannerSkeleton'
import { useGetProfileUserInfo } from '../../hooks/useGetProfileUserInfo'
import { useGlobalProfileUserInfo } from '../../store'

const ScheduleCallBanner = () => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const { profileInfo } = useGlobalProfileUserInfo()
  const { isLoading } = useGetProfileUserInfo()

  const { userInfo = {} } = profileInfo ?? {}
  const { validated_account = false } = userInfo ?? {}

  if (!IS_COMPANY) {
    return <></>
  }

  const renderVersion = isMobile ? (
    <img width={336} src={schedule_call_banner_mobile} />
  ) : (
    <img src={long_wait_time_banner} />
  )

  if (isLoading) return <ScheduleCallBannerSkeleton />

  return (
    <div className="mt-3 mb-3">
      <Link
        to="https://calendly.com/hutrit_next/30min?share_attribution=expiring_link"
        target="_blank"
        className="cursor-pointer"
      >
        {validated_account ? (
          <></>
        ) : (
          <div className="d-flex align-items-center w-100 justify-content-center">
            {renderVersion}
          </div>
        )}
      </Link>
    </div>
  )
}

export default ScheduleCallBanner
